import {apiHost} from "config/const";

export const header = {
  "Content-Type": "application/json",
};

export function callFetch(uri, settings) {
  return fetch(`${apiHost}${uri}`, settings)
    .then((response) => {
      if (response.ok) return response.json();
      return response.text().then((text) => {
        throw Error(text);
      });
    })
    .catch((error) => {
      console.error(error);
      return {err: true, message: JSON.parse(error.message)};
    });
}
